/* istanbul ignore file */
import React, { useContext, useEffect } from "react";



import { useIntervalWhen } from "rooks";
import { LikesButton  } from "./LikesButton";
import { PostConfigData, PostElementConfigData, ElementRotate, PostLayout, PostPanelConfigData, VotesConfigData, MessageConfigData, ChatConfigData, EmpyVotesConfig } from "../Shared/Party/PartyConfigData";
import { Carousel, CarouselProps, ScrollFunction } from "./Carousel";
import { LiveMessageFeed, LiveMessageFeedProps, RenderMessageForFeed } from "./LiveMessageFeed";
import { UIConfigContext } from "./UIConfigContext";
import { StateManagerContext } from "./StateManagerContext";
import { ActionButton, ActionHandler, CreateAction, EmptyActionData, IdActionData } from "./ActionButton";
import { FanboxStyling } from "./CSSUtilities";
import { CommentButtonPanel, CommentButtonPanelProps } from "./CommentButtonPanel";


//import { MessageDisplayProps, MessageConfigProps, Message } from "./Message";




export type PostDisplayProps = {
  postHeight: number;
  postWidth? : number;
  messageHeight: number;
  //selected?: string;
  userId: string;
  showLikeCommentButtons?: boolean;
  actionHandler?: ActionHandler;
  disableButtons? : boolean;
};


const calcFontBase = (width: number, height: number, fontBase: number, text: string, measureContext: React.MutableRefObject<CanvasRenderingContext2D | null>): number => {
  if (measureContext.current !== null) {
    measureContext.current.font = "regular " + fontBase + "px Roboto";
    const area = fontBase * measureContext.current.measureText(text ?? "").width;
    //console.log("Post Text Render: "  + (element.text?? ""));
    //console.log("Post Text Area @ " + fontBase + "px : " + area);
    const displayArea = width * height;
    const usage = area / displayArea;
    //console.log("Post Text Used Area: " + (usage * 100.0) + "% of " + displayArea);
    const useFontbase = Math.floor(0.5 * fontBase / Math.pow(usage, 0.5));
    //console.log("Suggested fontbase: " + useFontbase + "px");
    return useFontbase;
  }
  else
    return fontBase;
}

export type PostProps = {
  config: PostConfigData;
  display: PostDisplayProps;
};

type PanelPosition = 'left' | 'right' | 'only';

type PostPanelDisplayProps = {
  width: number;
  height: number;
  fontSize: number;
  measureContext: React.MutableRefObject<CanvasRenderingContext2D | null>;
  position: PanelPosition,
  voting?: VotesConfigData,
  title?: string,
  showOptional(id: string): void;
  actionHandler?: ActionHandler;
  disableButtons : boolean;
}




const PostPanel = ({ config, display }: { config: PostPanelConfigData, display: PostPanelDisplayProps }) => {

  const uiConfig = useContext(UIConfigContext);

  const hasButton = config.buttonText !== undefined || display.voting !== undefined;
  const buttonWidth = (display.width - 0.08 * display.height);
  const buttonHeight = (0.17 * display.height);
  const buttonMarginTop = (0.08 * display.height);
  const buttonColor = config.buttonColor === undefined ? 'darkPink' : config.buttonColor;
  const buttonTextColor = config.buttonTextColor === undefined ? 'white' : config.buttonTextColor;

  const optionalCall = config.buttonClick === undefined ? false : config.buttonClick.slice(0, 4) === 'opt:' || display.actionHandler !== undefined;
  const optionalId = (optionalCall && config.buttonClick !== undefined) ? config.buttonClick.slice(4) : undefined;

  if (hasButton) {
    console.log('post rendered with button; optionalCall = ' + optionalCall);
  }

  const availableHeight = hasButton ? (0.66 * display.height) : display.height;

  const imageElement = config.imageSrc !== undefined ?
    (<div style={{ backgroundImage: 'url(' + config.imageSrc + ')', height: availableHeight + "px", width: display.width + "px", border: "1px", borderColor: "red", backgroundRepeat: "no-repeat", backgroundSize: "contain", backgroundPosition: 'center' }} ></div>)
    : undefined;



  var textfontSize = display.measureContext !== null ? 
  calcFontBase(display.width,
     availableHeight - (hasButton ? (buttonHeight + 2 * buttonMarginTop) : 0),
    display.fontSize,
    config.text ?? "Test",
    display.measureContext) :
    display.fontSize; //display.fontSize < 0 ? (display.measureContext !== null ? calcFontBase(display.width, availableHeight - (hasButton ? (buttonHeight + 2 * buttonMarginTop) : 0), -display.fontSize, config.text ?? "Test", display.measureContext) : -display.fontSize) : display.fontSize;
  const fs = uiConfig.textLayout.getFontSizeForHeight(display.width, availableHeight , config.text ?? "Test"); //- (hasButton ? (buttonHeight + 2 * buttonMarginTop) : 0)
  textfontSize = fs === 0 ? 14 : (fs > 36 ? 36 : fs);

  const styling: FanboxStyling = {
    width: buttonWidth,
    height: buttonHeight,
    color: {
      foreground: display.disableButtons ? 'white' : buttonTextColor,
      background: display.disableButtons ? 'midGray' : buttonColor
    },
    boundary: {
      margin: {
        quadType: 'margin',
        top: buttonMarginTop,
        bottom: 0,
        left: 0,
        right: 0,
      }
    },
    font: {
      size: display.fontSize,
      weight: 'regular'
    }
  }

  const handler: ActionHandler = display.disableButtons ? ((action) => { return true;}) : display.actionHandler ?? ((action) => {
    const id = action.get('id') ?? '';
    if (optionalCall)
      display.showOptional(id);
    return true;
  });

  const action = CreateAction('onClick', [], handler);
  const actionData = IdActionData(optionalId ?? '');

  return (<div
    style={{
      width: display.width + "px",
      maxWidth: display.width + "px",
      minWidth: display.width + "px",
      height: display.height + "px",
      maxHeight: display.height + "px",
      minHeight: display.height + "px",
      display: 'flex',
      flexDirection: 'column',
      justifyContent: (config.text === undefined ? 'center' : 'left'),
      marginLeft: display.position === 'right' ? "5px" : "0px",
      marginRight: display.position === 'left' ? "5px" : "0px"


    }}
  >
    {
      (config.text !== undefined) && <span style={{ fontFamily: 'Roboto', fontWeight: 400, fontSize: textfontSize, color: 'white' }}>{config.text}</span>
    }
    {
      (config.text === undefined && imageElement !== undefined && config.imageClick !== undefined) &&
      <a href={config.imageClick} target="_blank" rel="noreferrer">
        {imageElement}
      </a>
    }
    {
      (config.text === undefined && imageElement !== undefined && config.imageClick === undefined) &&
      imageElement
    }
    {
      (config.buttonText !== undefined) && (optionalCall ? (<ActionButton text={config.buttonText ?? ''}
        styling={styling}
        action={action}
        actionData={actionData}
        prompt={'left'}

      />) : (<a href={config.buttonClick} target="_blank" rel="noreferrer" style={{ textDecoration: 'none' }}>
        <ActionButton text={config.buttonText ?? ''}
          styling={styling}
          action={action}
          actionData={actionData}
          prompt={'left'} />
      </a>))
    }
    {
      (display.voting !== undefined) && (<div style={{ marginTop: (0.08 * display.height) + 'px', display: 'flex', flexDirection: 'row', justifyContent: 'center', minWidth: display.width + 'px' }}><LikesButton unlike={false} voting={display.voting} width={0.65 * display.width} height={0.17 * display.height} background="#606060" fontBase={display.fontSize} radius={0.08 * display.height} text={display.title} padding={20} /></div>)
    }
  </div>)
}

type PostElementDisplayProps = {
  width: number;
  height: number;
  fontSize: number;
  measureContext: React.MutableRefObject<CanvasRenderingContext2D | null>;
  forceSingle: boolean,
  showOptional: (id: string) => void;
  actionHandler?: ActionHandler;
  disableButtons : boolean;
}

type PostElementProps = {
  config: PostElementConfigData,
  display: PostElementDisplayProps
}

const PostElement = ({ config, display }: PostElementProps): JSX.Element => {

  const votingPrimary = config.secondary !== undefined ? (config.secondary.text === undefined ? true : false) : true;
  const votingSecondary = config.secondary !== undefined ? (config.secondary.text === undefined ? false : true) : false;

  const panelWidth = (config.secondary === undefined || config.layout === 'primary-only') ? display.width - 20 : display.width * 0.5 - 15;
  const primaryPanelProps: PostPanelDisplayProps = {
    width: panelWidth,
    height: display.height,
    fontSize: display.fontSize,
    measureContext: display.measureContext,
    position: (config.secondary === undefined || config.layout === 'primary-only' || display.forceSingle) ? 'only' : (config.layout === 'primary-left' ? 'left' : 'right'),
    voting: votingPrimary ? config.voting : undefined,
    title: config.title,
    showOptional: display.showOptional,
    actionHandler: display.actionHandler,
    disableButtons : display.disableButtons
  }

  const secondaryPanelProps: PostPanelDisplayProps = {
    width: panelWidth,
    height: display.height,
    fontSize: display.fontSize,
    measureContext: display.measureContext,
    position: config.layout === 'primary-left' ? 'right' : 'left',
    voting: votingSecondary ? config.voting : undefined,
    title: config.title,
    showOptional: display.showOptional,
    actionHandler: display.actionHandler,
    disableButtons : display.disableButtons
  }

  return (<div
    style={{
      width: display.width + "px",
      maxWidth: display.width + "px",
      minWidth: display.width + "px",
      height: display.height + "px",
      maxHeight: display.height + "px",
      minHeight: display.height + "px",
      display: 'flex',
      flexDirection: (config.secondary === undefined || config.layout === 'primary-only' || display.forceSingle) ? 'column' : (config.layout === 'primary-left' ? 'row' : 'row-reverse'),
      margin: '10px'
    }}
  >
    <PostPanel config={config.primary} display={primaryPanelProps} />
    {
      (config.secondary !== undefined && config.layout !== 'primary-only' && !display.forceSingle) && <PostPanel config={config.secondary} display={secondaryPanelProps} />
    }
  </div>)

}



//const TITLE_HEIGHT = 2.0;
const BUTTON_HEIGHT = 2.0;



const selectToShow = (
  elements: PostElementConfigData[],
  indices: number[],
  layout: PostLayout,
  rotate: ElementRotate,
  imageIndex: number,
  tickCount: number
): [PostElementConfigData, number][] => {
  const maxElements = layout === "double-element" ? 2 : 1;

  if (maxElements < elements.length) {
    if (rotate === 'pyramid') {

      const allImages = new Array<[PostElementConfigData, number]>();
      for (let i = 0; i < indices.length; i++) {
        allImages.push([elements[i], indices[i]]);
      }
      let displayImages = allImages.sort((a, b) => {
        return (a[0].voting?.likes ?? 0) - (b[0].voting?.likes ?? 0) //supportA - supportB;
      });

      const ns =
        elements.length - tickCount < maxElements ? maxElements : elements.length - tickCount;

      displayImages = displayImages.slice(0, ns);
      const ret = new Array<[PostElementConfigData, number]>();

      const index1 = Math.round(Math.random() * displayImages.length - 0.5);
      ret.push(displayImages[index1]);
      if (maxElements > 1) {
        displayImages.splice(index1, 1);
        const index2 = Math.round(Math.random() * displayImages.length - 0.5);
        ret.push(displayImages[index2]);
      }

      return ret;
    }
    else if (rotate === 'random') {
      const allImages = new Array<[PostElementConfigData, number]>();
      for (let i = 0; i < indices.length; i++) {
        allImages.push([elements[i], indices[i]]);
      }

      const ret = new Array<[PostElementConfigData, number]>();

      while (allImages.length > 0) {
        const index = Math.round(Math.random() * allImages.length - 0.5);
        ret.push(allImages[index]);
        allImages.splice(index, 1);
      }
      return ret;
    }
    else if (rotate === 'sequential' || rotate === 'carousel') {
      const allImages = new Array<[PostElementConfigData, number]>();
      for (let i = 0; i < indices.length; i++) {
        allImages.push([elements[i], indices[i]]);
      }
      return allImages;
    }
    else if (maxElements > 1) {
      return [
        [elements[imageIndex], indices[imageIndex]],
        [elements[imageIndex + 1], indices[imageIndex + 1]],
      ];
    }
    else {
      return [[elements[imageIndex], indices[imageIndex]]];
    }
  }
  else if (maxElements > 1) {
    return [
      [elements[imageIndex], indices[imageIndex]],
      [elements[imageIndex + 1], indices[imageIndex + 1]],
    ];
  }
  else {
    return [[elements[imageIndex], indices[imageIndex]]];
  }
};


export const Post = ({ config, display }: PostProps) => {
  const initFuncs = React.useRef<boolean>(false);
  const uiConfig = React.useContext(UIConfigContext);
  const postWidth = display.postWidth === undefined ? uiConfig.width : display.postWidth;
  const stateManager = React.useContext(StateManagerContext);
  //const [messagIndex, setMessageIndex] = React.useState(0);
  const [tickCount, setTickCount] = React.useState(0);
  const measureContext = React.useRef(document.createElement("canvas").getContext("2d"));
  const [userMessage, setUserMessage] = React.useState<MessageConfigData | null>(null);
  const [userMessagePanel, setUserMessagePanel] = React.useState<JSX.Element | null>(null);
  const resizeChatArea = React.useRef<boolean>(false);
  const [userMessagePanelHeight, setUserMessagePanelHeight] = React.useState<number>(0);

  const elementList = React.useRef<[PostElementConfigData, number][]>([]);
  const postId = React.useRef<string>('');
  const carouselScrollRightFunction = React.useRef<ScrollFunction | null>(null);

  const showButtons = display.showLikeCommentButtons ?? true;

  const userMessageHandler = (userMessage: MessageConfigData) => {
    console.log("LiveMessageFeed: User message call back");
    setUserMessage(userMessage);
    setUserMessagePanel(RenderMessageForFeed(userMessage, uiConfig.fanboxColor('darkGray'), uiConfig.fontBase, stateManager.user().fanbox.id, 1111111, uiConfig.showEventOverlay));
    resizeChatArea.current = true;
  }
  if (!initFuncs.current) {
    initFuncs.current = true;

    uiConfig.setUserMessageHandler(userMessageHandler);
  }

  if (config.itemId !== postId.current) {
    elementList.current = [];
    postId.current = config.itemId;
    setUserMessage(null);
    setUserMessagePanel(null);
    setUserMessagePanelHeight(0);
  }

  if (elementList.current.length === 0) {
    const indices = new Array<number>();
    for (let i = 0; i < config.elements.length; i++) indices.push(i);
    elementList.current = config.elements.length > 0 ? selectToShow(
      config.elements,
      indices,
      config.layout,
      config.rotate,
      config.elementIndex ?? 0,
      tickCount
    ) : [];
  }



  const carouselCallback = (func: ScrollFunction) => {
    carouselScrollRightFunction.current = func;
  }




  const buttonHeight = BUTTON_HEIGHT * uiConfig.fontBase;
  const elementHeight = display.postHeight - 2 * uiConfig.fontBase - buttonHeight;
  const displayElements = elementList.current.length > 0 ? elementList.current.map((value, _index) => { return value[0]; }) : [];
  const displayTitle = displayElements.length > 0 ? (displayElements[0].title === undefined ? config.title : (displayElements[0].title ?? "")) : config.title;
  const author = config.author === undefined ? 'me' : config.author;
  const titleMarkdown = (author[0] === "@" ? "" : "@") + author + " " + displayTitle;




  const maxElements = config.layout === 'single-element' ? 1 : 2;
  useIntervalWhen(
    () => {
      if ((config.rotate !== "carousel") && (config.elements.length > 2 || (config.elements.length > 1 && config.layout === "single-element"))) {
        setTickCount(tickCount + 1);
        //if (voteStart !== undefined) voteStart.current = 10 * tickCount;
        if (config.rotate === 'sequential') {
          const elementIndex = config.elementIndex ?? 0;
          const nx = elementIndex < config.elements.length - 1 ? elementIndex + 1 : 0;
          config.elementIndex = nx;
          if (carouselScrollRightFunction.current !== null)
            carouselScrollRightFunction.current();
        }
      }
    },
    10000,
    true,
  );

  useEffect(() => {
    if (userMessagePanel !== null && resizeChatArea.current) {
      resizeChatArea.current = false;

      const key = userMessagePanel.key;
      var height = 0;
      if (key !== null) {
        const element = document.getElementById(key);
        const rect = element?.getBoundingClientRect();
        if ((rect !== null) && (rect !== undefined)) {
          height = rect.height;
        }
      }
      setUserMessagePanelHeight(height);
    }
    else if(resizeChatArea.current)
    {
      setUserMessagePanelHeight(0);
    }
  })

  const postElementDisplayProps: PostElementDisplayProps = {
    width: postWidth / maxElements,
    height: elementHeight,
    fontSize: 20,
    measureContext: measureContext,
    forceSingle: maxElements > 1,
    showOptional: uiConfig.showOptional,
    actionHandler: display.actionHandler,
    disableButtons : display.disableButtons ?? false

  }

  const carouselProps: CarouselProps = {
    display: maxElements,
    width: postWidth,
    height: elementHeight,
    scrollButtonWidth: 0.1 * postWidth,
    idPrefix: 'Post_' + config.itemId + '_Carousel',
    userControlled: config.rotate === 'carousel',
    borderRadius: 0,
    scrollRight: carouselCallback,
    panels: displayElements.map((element: PostElementConfigData) => {
      return <PostElement config={element} display={postElementDisplayProps} />
    })
  }

  const commentVoting =  (config.voting === undefined ? config.elements[config.elementIndex ?? 0].voting : config.voting) ??  EmpyVotesConfig();
  const commentClickHandler: ActionHandler = (_action): boolean => {
        //if (stateManager.user().cognito !== undefined) {
        const id = config.messageDisplay === 'element' ? config.elements[config.elementIndex ?? 0].chatId : config.chatId;
        const data: { [key: string]: string } = { id: id ?? '', post: JSON.stringify(config) };
        if (config.chatId !== undefined)
          data.chatId = config.chatId;
        uiConfig.showEventOverlay('reply', data);
        return true;
        /* }
         else {
           uiConfig.showEventOverlay('signIn', {});
         }*/
  
      }

  const buttonProps: CommentButtonPanelProps = {
    width: postWidth,
    height: buttonHeight,
    voting: commentVoting,
    keyIndex: "Post_" + config.itemId + "_Buttons_",
    commentButton : userMessage === null, 
    commentClickHandler
    
  }

  const chatId = config.messageDisplay === 'element' ? config.elements[config.elementIndex ?? 0].chatId : config.chatId;
  const showChat = config.messageDisplay !== 'none' && chatId !== undefined;

  const feedProps: LiveMessageFeedProps = {
    chatId: chatId ?? '',
    chat : { 
            itemId : '',
            chatType : 'comment',
            messages : [],
            threads : [],
            startTime : 0,
            endTime : 0
          },
    height: display.messageHeight - userMessagePanelHeight,
    currentUser: display.userId,
  }

  const showNoElements = config.elements.length === 0 && userMessagePanel === null;



  return (<div style={{
    width: postWidth+ "px",
    minWidth: postWidth + "px",
    maxWidth: postWidth + "px",
    height: (display.messageHeight + display.postHeight) + "px",
    minHeight: (display.messageHeight + display.postHeight) + "px",
    maxHeight: (display.messageHeight + display.postHeight) + "px",
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: uiConfig.fanboxColor('darkGray')

  }}>
    <div style={{
      width: postWidth + "px",
      minWidth: postWidth + "px",
      maxWidth: postWidth+ "px",
      backgroundColor: "white",
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'left'
    }}>
      <span style={{ fontSize: uiConfig.fontBase, textAlign: "left", paddingLeft: uiConfig.fontBase + "px", color: "black" }}>
        {titleMarkdown}
      </span>

    </div>
    <Carousel {...carouselProps} />


    {showNoElements && <div style={{
      width: postWidth + "px",
      minWidth: postWidth + "px",
      maxWidth: postWidth+ "px",
      backgroundColor: "white",
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'left'
    }}>
      <span style={{ fontSize: uiConfig.fontBase * 2, textAlign: "left", paddingLeft: uiConfig.fontBase + "px", color: "white" }}>
        There are no posts to display.
      </span>
    </div>}
    {(userMessagePanel !== null) && userMessagePanel}
    {showChat && <LiveMessageFeed {...feedProps} key={config.itemId + 'lmf'} />}
    {showButtons && <CommentButtonPanel {...buttonProps} />}


  </div>)
};

